import { useRouteError } from "react-router";

import Typography from '@mui/joy/Typography';
import {CssVarsProvider}	from '@mui/joy/styles';


export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
  	<CssVarsProvider defaultMode="dark">

		<Typography level="h1" align="center"  mb={2} mt={3}>
			Oops!
		</Typography>
		
		<Typography level="h2" align="center"  mb={2} mt={3}>
			Sorry, an unexpected error has occurred.
		</Typography>		

		<Typography level="h4" align="center"  mb={2} mt={3}>
			{error.statusText || error.message}
		</Typography>		
	</CssVarsProvider>
  );
}